import { render, staticRenderFns } from "./CollaboratorsTab.vue?vue&type=template&id=655c6729&"
import script from "./CollaboratorsTab.vue?vue&type=script&lang=js&"
export * from "./CollaboratorsTab.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorsTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports